import classes from './style.module.scss';

const Header = () => {
    return (
        <div className={classes.header}>
            <div className={classes.container}>
                <h1 className={classes.title}>
                    Клуб бильярдного спорта, комфортного отдыха и любимых
                    развлечений
                </h1>
                <div className={classes.description}>
                    <p>Бильярд</p>
                    <p>Кухня</p>
                    <p>Спорт-бар</p>
                    <p>Удобная парковка</p>
                </div>
            </div>
        </div>
    );
};

export default Header;
